export enum DbRestoreStateEnum {
  Idle = 'Idle',
  Running = 'Running',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
}
